import styled from 'styled-components';
import { colors } from 'pages/new-questions/styles/common';

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100001;
  padding: 16px;
`;

export const ModalContainer = styled.div`
  background: ${colors.white};
  border-radius: 16px;
  padding: 32px;
  width: 100%;
  max-width: 560px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  animation: fadeInModal 0.3s ease-out;

  @keyframes fadeInModal {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @media screen and (max-width: 768px) {
    padding: 24px 16px;
  }
`;

export const ModalIcon = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: ${colors.redBackground};
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    font-size: 24px;
    color: ${colors.red};
  }
`;

export const ModalTitle = styled.h3`
  font-family: Manrope, sans-serif;
  font-weight: 700;
  font-size: 18px;
  line-height: 26px;
  color: ${colors.black};
  margin: 0;
  text-align: center;
`;

export const ModalSubtitle = styled.p`
  font-family: Manrope, sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: ${colors.gray};
  margin: 0;
  text-align: center;
`;

export const ModalTextArea = styled.textarea`
  width: 100%;
  min-height: 120px;
  padding: 16px;
  border: 1px solid ${colors.borderGray};
  border-radius: 8px;
  resize: vertical;
  font-family: Manrope, sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: ${colors.black};

  &::placeholder {
    color: ${colors.gray};
  }

  &:focus {
    outline: none;
    border-color: ${colors.primary};
  }
`;

export const TextAreaWrapper = styled.div`
  width: 100%;
`;

export const CharacterCount = styled.span<{ isNearLimit?: boolean }>`
  display: block;
  text-align: right;
  font-family: Manrope, sans-serif;
  font-size: 12px;
  line-height: 16px;
  color: ${({ isNearLimit }) => (isNearLimit ? colors.red : colors.gray)};
  margin-top: 4px;
`;

export const ModalActions = styled.div`
  display: flex;
  width: 100%;
  gap: 12px;
  margin-top: 8px;

  @media screen and (max-width: 768px) {
    flex-direction: row;
  }
`;

export const ModalButtonBack = styled.button`
  flex: 1;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  background: ${colors.white};
  border: 1px solid ${colors.borderGray};
  border-radius: 8px;
  cursor: pointer;
  font-family: Manrope, sans-serif;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  color: ${colors.black};
  transition: all 0.2s;

  &:hover {
    background: ${colors.grayThree};
  }
`;

export const ModalButtonSubmit = styled.button`
  flex: 1;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  background: ${colors.primary};
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-family: Manrope, sans-serif;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  color: ${colors.white};
  transition: all 0.2s;

  &:hover:not(:disabled) {
    background: ${colors.primaryDark};
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
